import axios from "axios";

export const deleteCatchReport = async (catchReportID: number) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API}/CatchReport/report?CatchReportID=${catchReportID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
